(function () {
  function initFlipCards() {
    var cards = document.querySelectorAll('[data-flip-card]');

    cards.forEach(function (card) {
      var triggers = card.querySelectorAll('[data-flip-trigger]');

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var isFlipped = card.classList.toggle('is-flipped');

          triggers.forEach(function (t) {
            t.setAttribute('aria-expanded', isFlipped ? 'true' : 'false');
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlipCards);
  } else {
    initFlipCards();
  }
})();